import React, { Component  } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable, MDBCard, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
import html2canvas from 'html2canvas';  
import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
import ReactExport from "react-export-excel";
//import ModelDescription from './ModelDescription';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

import Moment from 'react-moment';
import Modelshowstudent from '../teacher/Modelshowstudent';
import ModelcuDescription from './ModelcuDescription';
import ModelcuNotApprove from './ModelcuNotApprove';
import Modeladdshortmoduleforcu from '../creditbank/Modeladdshortmoduleforcu';



//import ModelRegister from './ModelRegister';


//import Modaladdcurriculumopen from './Modaladdcurriculumopen';
//import Modeltest from './Modeltest';
//import Modaladdteacher from './Modaladdteacher';

      const date = new Date();
      const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
      const dates = year+"-"+month+"-"+day ;

export default class Admincumainshort extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          modal: false,
         
          type:'1',
        
          year:'2564',
          search: '',

          Curriculum:[],
          Studentcb_ID:'',
          Citizen:'',
          Approvecudata:[],
          Approve:'2', //อนุมัติ


   
          Course_ID:'',
          Course_Name_TH:'',
          Course_Name_En:'',
          Course_Credit:'',
          Course_Year:'',
          Course_T_Hour:'',
          Course_Detail_TH:'',
          Course_Detail_EN:'',

          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.time = this.time.bind(this);
        this.sentpdf = this.sentpdf.bind(this);
       
        this.refreshPage = this.refreshPage.bind(this);
        this.onChange = this.onChange.bind(this);


        this.getCurriculumopen = this.getCurriculumopen.bind(this);
        this.getCitizenstu = this.getCitizenstu.bind(this);
        this.linkto = this.linkto.bind(this);
        this.getApprovecu = this.getApprovecu.bind(this);
        
      }


      onChange(value) {
        
           const Courseselect = this.state.Course.filter( ({ Course_ID }) => Course_ID.substring(0, 7) === value.substring(0, 7) );
         //  const idemp = value;
         //  console.log(Courseselect[0].Course_ID);
           this.setState({ Course_ID : Courseselect[0].Course_ID.substring(0, 7) });
           this.setState({ Course_Name_TH : Courseselect[0].Course_Name_TH });
           this.setState({ Course_Name_En : Courseselect[0].Course_Name_En });
           this.setState({ Course_Credit : Courseselect[0].Course_Credit });
           this.setState({ Course_Year : Courseselect[0].Course_Year });
           this.setState({ Course_T_Hour : Courseselect[0].Course_T_Hour });
           this.setState({ Course_Detail_TH : Courseselect[0].Course_Detail_TH });
           this.setState({ Course_Detail_EN : Courseselect[0].Course_Detail_EN });

           this.getCurriculumopen()

        }

        //ดึงหลักสูตรที่เปิดสอน
        getCurriculumopen() {
          setTimeout(() => {
             //ภายใน
             api.get('index/getCurriculumopen/'+this.state.Course_ID)
             .then(res => {
             //  console.log(res);
             //  this.setState({ bankname: res.data, loading: false })
               this.setState({ Curriculumopen: res.data})
             }) 
           }, 0);
        }

            //ดึงหลักสูตรที่เปิดสอนยืนพิจารณา
         getApprovecu() {
              setTimeout(() => {
                 //ภายใน
                 api.get('index/getShortcourseforcu/'+localStorage.getItem('Univ_ID'))
                 .then(res => {
                 //  console.log(res);
                 //  this.setState({ bankname: res.data, loading: false })
                   this.setState({ Approvecudata: res.data})
                 }) 
               }, 0);
        }


      
      linkto(event) {
          console.log(event.target.value)
      //    console.log("fdfd")
          const id = event.target.value;

        //  const id = this.props.Curriculumopen_ID;
          setTimeout(() => {
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("Curriculumopen_ID", id);
              datafrm.append("Approve", this.state.Approve);
              datafrm.append("comment", this.state.comment);
              datafrm.append("date", dates);
              
              
              api.post("index/updateApprovepass/",datafrm,{
                  headers: {
                      'content-type': 'multipart/form-data'
                  }
              })

              .then(res => {
              //    console.log(res);
                  if (res.status === 200) {
                  //  alert("บันทึกสำเร็จ")
                          Swal.fire({
                              title: 'ยืนยันการพิจารณาสำเร็จ',
                              icon: 'success',
                              // showCancelButton: true,
                              confirmButtonText: 'ตกลง',
                              // cancelButtonText: 'No, keep it'
                              }).then((result) => {
                                this.getApprovecu()
                              })
                          }
                  })
               // this.toggle()

                this.getApprovecu()
              //  this.getplan();
          }, 1000);
      }

  

      getCitizenstu() {
        setTimeout(() => {
           //ภายใน
           api.get('index/getCitizenstu/'+localStorage.getItem('Studentcb_ID'))
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ Citizen: res.data[0].Studentcb_Citizen_ID})
           }) 
         }, 0);
    }


      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

 
         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }


          componentDidMount(){
           
            this.setState({ Studentcb_ID:localStorage.getItem('Studentcb_ID')}) 

         if (localStorage.getItem('name') == null) {
               
                 // window.location.href = 'https://e-student.kpru.ac.th/vaccinekpru'
               
            } else {
        
            }
                      api.get('index/getCurriculumforteacher/'+ localStorage.getItem('Citizen_ID'),
                   //     Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                      {headers: {
                        // Authorization: 'Bearer ' + localStorage.getItem('myData')
                      }
                      })
                      //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                      .then(res => {
                         // console.log(res.data[0].id)
                       //  console.log(res.data)
                      //   const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                       //  console.log(Course)
                          const Curriculum = res.data;
                          this.setState({ Curriculum });
                      })    
                this.getApprovecu();  
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };


    render() {

      //console.log(this.state.Course_ID)
      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
     
      
      const { Option } = Select;
     // const newDate = moment(new Date()).format("DD/MM/YYYY");
     // const newDate = new Date("MM/DD/YYYY");
      
      console.log(dates);


             //ชุดตาราง
             const data = {
              columns: [
                {
                  label: '#',
                  field: 'list',
                  sort: 'list',
                  width: 150
                },
                {
                  label: 'ปี',
                  field: 'Course_YEAR',
                  sort: 'Course_YEAR',
                  width: 150
                },
                {
                  label: 'เทอม',
                  field: 'Curriculumopen_TEAM',
                  sort: 'Curriculumopen_TEAM',
                  width: 270
                },
                {
                  label: 'ชื่อหลักสูตรภาษาไทย',
                  field: 'Curriculumopen_Full_Name_TH',
                  sort: 'Curriculumopen_Full_Name_TH',
                  width: 200
                },
                {
                  label: 'ชื่อหลักสูตรภาษาอังกฤษ',
                  field: 'Curriculumopen_Full_Name_EN',
                  sort: 'Curriculumopen_Full_Name_EN',
                  width: 100
                },
                {
                  label: 'จำนวนชั่วโมง',
                  field: 'Curriculumopen_CH',
                  sort: 'Curriculumopen_CH',
                  width: 150
                },
                {
                  label: 'จำนวนลงทะเบียน',
                  field: 'NUMID',
                  sort: 'NUMID',
                  width: 150
                },
                {
                  label: 'วันเริ่ม',
                  field: 'Curriculumopen_Date_START',
                  sort: 'Curriculumopen_Date_START',
                  width: 150
                },
                {
                  label: 'วันสิ้นสุด',
                  field: 'Curriculumopen_Date_END',
                  sort: 'Curriculumopen_Date_END',
                  width: 150
                },
               
                {
                  label: 'จัดการ',
                  field: 'Curriculumopen_EDIT',
                  sort: 'Curriculumopen_EDIT',
                  width: 150
                }


              ],
    
              rows: [...this.state.Approvecudata.map((data, i) => (
                {
                   list: <>{i+1}</>,
                   Course_YEAR: <>{data.Shortcourse_Course_YEAR}</>,
                   Curriculumopen_TEAM: <>{data.Shortcourse_Team}</>,
                   Curriculumopen_Full_Name_TH: <>{data.Shortcourse_Nameshortterm_TH}</>,
                   Curriculumopen_Full_Name_EN: <>{data.Shortcourse_Nameshortterm_EN}</>,
                   Curriculumopen_CH: <>{data.Shortcourse_Numch}</>,
                   NUMID: <>{data.Shortcourse_Numregis}</>,
                   Curriculumopen_Date_START: <>{data.Shortcourse_Timestart}</>,
                   Curriculumopen_Date_END: <>{data.Shortcourse_Timeend}</>,
                  
                   Curriculumopen_EDIT: (()=> { 
                    return <>  
                    <Modeladdshortmoduleforcu Course_ID={data.Shortcourse_Course_ID} Shortcourse_ID={data.Shortcourse_ID}  />
                    {/* <MDBBtn color="primary" value={data.Curriculumopen_ID}  onClick={this.linkto}><MDBIcon icon="check" /> อนุมัติ</MDBBtn>   */}
                    {/* <ModelcuNotApprove Curriculumopen_ID={data.Curriculumopen_ID} getApprovecu={this.getApprovecu}  /> */}
                    </>
                     // if (<>data.Curriculumopen_Status_ONOFF === '1'</>) {
                     //   return <Switch  defaultChecked value={data.Curriculumopen_ID} onClick={this.onChangeswit}  />
                     // }else{
                     // }
                     })(),

                    random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
                
                }
               ))]
              
          
          };
    
          const persons = <MDBDataTable
         // searching ={true}
          searchLabel="ค้นหา ชื่อหลักสูตร"
          striped
          bordered
          small 
          entries={20}
         // entriesOptions={["10", "20"]}
          order={["age", "desc"]}
          data={data}
          entriesLabel="จำนวนที่แสดง "
          infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
          paginationLabel={["ย้อนกลับ", "ถัดไป"]}
          responsive 
          sortRows={['random']}
    />
    //ชุดตาราง




       
        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
        {/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
        <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> ตรวจสอบข้อมูลหลักสูตรระยะสั้น</h4> } extra={<a href="#"><p>อาจารย์{localStorage.getItem('name')}</p></a>} >

                        <Breadcrumb>
                          <Breadcrumb.Item>พิจารณาหลักสูตรระยะสั้น</Breadcrumb.Item>
                        </Breadcrumb>
                        <br/>

                 <MDBRow>
                 
                        <MDBCol sm="12">
                            <MDBJumbotron fluid>
                            <MDBContainer fluid>
                            <h2 className="display-5 deep-purple-text text-center">ตรวจสอบข้อมูลหลักสูตรระยะสั้นยื่นพิจารณา </h2>
                                {/* <h4 className="display-5 deep-purple-text">รายละเอียดวิชา</h4> */}
                                <MDBCol>
                                  {persons} 
                                </MDBCol>
                               
                            </MDBContainer>
                            </MDBJumbotron>    
                      
                        </MDBCol>
                 </MDBRow>


        </Card>

       
            </MDBContainer>
        )
    }
}
